///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import * as _ from "lodash";

const ignoreNullValues = object => {
  let keysWithValues = [];

  _.keys(object).forEach(key => {
    let value = object[key];

    if (_.isString(value) && value === "") return;

    if (_.isNil(value)) return;

    if (_.isObject(value) && _.isEmpty(value)) return;

    if (_.isArray(value) && _.isEmpty(value)) return;

    keysWithValues.push(key);
  });

  return _.pick(object, ...keysWithValues);
};

export default ignoreNullValues;
